import store from '@/store/index.js';
import { EventBus } from '@/event-bus';
import draftMixins from '@/components/mixins/Drafts.vue'
import postMixins from '@/components/mixins/Posts.vue'
import postCreatorMixins from '@/components/dash/postCreator/mixins/main.js'
import { convertNewsToDraft, patchDraft } from '../utils/draft.js';
import { resolveVariables } from '@/utils/resolveVariables.js'

export default {
    mixins: [draftMixins, postMixins, postCreatorMixins],
    methods: {
        async buildEvent(post, convert=false){
            const log = true;
            if (!post._bots || !post._bots.length || !post._bots[0].page) {
                console.warn("No bot/page found for this post", post)
                return false
            }
            const page = post._bots[0].page
            if (!this.allPages[page.id]) {
                console.warn("Page not found in allPages", page.id, this.allPages)
                return false
            }
        
            let draft = post.page.length && post.page[0].draft ? JSON.parse(post.page[0].draft) : post.draft ? post.draft.data : undefined

            if (convert) {
                if(!post.page || !post.page.length || !draft || !draft.saveAllFormData) {
                    draft = await convertNewsToDraft(post, true)
                }
            }
            

            if (!post.page[0]) {
                console.log("!post.page[0]", post)
            }
            
            const event =  {
                "id": post.id + page.id,
                "date": post.page && post.page.length ? post.page[0].posted_date || post.page[0].scheduled_date : post.scheduled_date || post.published_at,
                "formatedDate": null,
                "image": post.enclosure || (post.page[0] && post.page[0].enclosure),
                "status": null,
                "originalStatus": post.page && post.page.length ? ['removed', null, 'scheduled', 'posted', 'pending', 'failed', 'failed', 'draft', 'processing'][post.page[0].status + 1] : 'standby', //+1 pour inclure removed (removed = -1) ; status 5 = erreur auto-post retentable (backend: STATUS_ES_MAP.failed = [4,5]), mappé sur "failed"
                "type": null,
                "page": {
                    id: page.id,
                    avatar: this.allPages[page.id].avatar,
                    network: this.allPages[page.id].network,
                },
                "content": post.title,
                "draft": draft,
                "originalPost": post
            }

            //verifier si il s'agit post automatique

            //!post.page[0].storification : les storifications ne sont pas possible en automatique, mes les storifications crée par le user sont en status automatique
            if (post.page[0] && !post.page[0].isManualPost && !post.page[0].storification) {
             
                if (post._bots[0].post_text_layout == "description" && post.description) {
                    event.content = post.description
                }else if (post._bots[0].post_text_layout == "title" && post.title) {
                    event.content = post.title
                }else{
                    event.content = ""
                }

                if (post.media == "photo") {
                    event.type = 'image'
                    if (post.url) {
                        event.content += `\n${post.url}`
                    }
                }
                if (!event.draft) event.draft = {}
            }

            //status
            if (!event.status) {

                if (post.page && post.page.length) {

                    if (
                        (['scheduled','draft'].includes(event.originalStatus) || (event.originalStatus === 'processing' && event.originalPost.scheduled_date)) &&
                        event.originalPost.page[0].affectedTo && 
                        event.originalPost.page[0].affectedTo.optionValidation && 
                        !['null', 'false'].includes(event.originalPost.page[0].affectedTo.optionValidation) &&
                        (!event.originalPost.page[0].wait_validation || event.originalPost.page[0].wait_validation == 'null')

                    ) {
                 
                        if (
                            this.currentUser && (
                                (event.originalPost.page[0].affectedTo.user && event.originalPost.page[0].affectedTo.user.id == this.currentUser.id) ||
                                (event.originalPost.page[0].affectedTo.users && event.originalPost.page[0].affectedTo.users.length && event.originalPost.page[0].affectedTo.users.some(user => user.id == this.currentUser.id))
                            )
                        ) {
                            event.status = 'to_validate'
                        }else{
                            event.status = 'awaiting_approval'
                        }
                      
                       
                    }else if (post.page[0].pending_approval) {
                        event.status = 'pending';
                    }else if (event.originalStatus === 'processing') {
                        event.status = event.originalPost.scheduled_date ? 'scheduled' : 'pending';
                    } else {
                        event.status = event.originalStatus;
                    }
                   
                } else {
                    event.status = 'standby'
                }
            }

            //type
            if (!event.type) {
                if (false && post.type === 'newsFeed') { // eslint-disable-line no-constant-condition
                    //pas de type storification ni story
                    event.type = {photo: 'image', image: 'image', video : 'video', document: 'document', story: 'story'}[post.media] || undefined
                }else if (post.page && post.page.length) {
                    if((post.page[0].network == "instagram" || post.page[0].network == "facebook") && (
                        (post.page[0].story || post.page[0].story_multiple || post.page[0].storification || post.page[0].isStory) || //post.page[0].new_story_creation le soucis avec new_story_creation c'est qu'il est present sur un post avec storification
                        (post.page[0].isDraft && (post.draft?.data?.tab || draft?.tab) == 'story')
                    )) {
                        event.type = 'story'
                        event.content = post.page[0].network == "facebook" && !post.page[0].shared_to_facebook ? 'Stories facebook' : 'Stories instagram'
                      
                    }else if (post.page[0].multipleMedias && post.page[0].multipleMedias.length){
                        event.type = 'carousel'
                    }else if (post.page[0].carousel && post.page[0].carousel.length) {
                        if (post.page[0].carousel.length > 1) {
                            event.type = 'carousel'
                        }else{
                            if (['png', 'jpeg', 'jpg'].includes(post.page[0].carousel[0].url.split('.').slice(-1)[0]) || ['png', 'jpeg', 'jpg'].includes(post.page[0].carousel[0].ext)) {
                                event.type = 'image'
                            }else{
                                event.type = 'video'
                            }
                        }
                    }
                    else if(post.page[0].document_title){
                        event.type = 'document'
                    }
                    else if(post.page[0].network == "instagram" && post.page[0].typePost == "video") {
                        event.type = 'reel'
                    }
                    else if(post.page[0].typePost == "video") {
                        event.type = 'video'
                    }
                    else if(post.page[0].typePost == "image") {
                        event.type = 'image'
                    }
                    else if(post.page[0].network == "instagram" && post.page[0].carousel && post.page[0].carousel.length) {
                        event.type = 'image'
                    }
                    else if(post.page[0].enclosure) {
                        if (['png', 'jpeg', 'jpg'].includes(post.page[0].enclosure.split('.').slice(-1)[0])) {
                            event.type = 'image'
                        }else{
                            event.type = 'video'
                        }
                    }
                
                }  
                else {
                    // news standby with medias (new parsing)
                    if(post.medias?.length) {
                        if(post.medias[0].type == 'video')
                            event.type = 'video'
                        else if(post.medias.length > 1)
                            event.type = 'carousel'
                        else
                            event.type = 'image'

                    }
                }
        
                // event.type = 'story'
                // ['image','','','','', ''][Math.floor(Math.random() * 6)]
            }
        
            if (!event.date) {
                log && console.warn("BuildEvent error : Pas de date trouvé pour ce post", post)
                return false
            }else{
                const dateInstance = new Date(event.date)
                const isCurrentYear = dateInstance.getFullYear() === new Date().getFullYear()
                const options = isCurrentYear ? { day: '2-digit', month: 'short' } : { day: '2-digit', month: 'short', year: 'numeric' }
                const options2 = { hour: '2-digit', minute: '2-digit' }
                event.formatedDate = dateInstance.toLocaleDateString('fr-FR', options).replace('.', '') + ` à ${dateInstance.toLocaleTimeString('fr-FR', options2)}`;
            }
            if (!event.status) {
                log && console.warn("BuildEvent error : Pas de status trouvé pour ce post", post)
                return false
            }
        
            if (!event.type) {
                log && console.info("BuildEvent error : Pas de type trouvé pour ce post", post)
                // return false
            }
        
            if (!event.draft) {
                log && console.warn("BuildEvent error : Pas de draft trouvé pour ce post", post)
                if (event.originalPost.type !== 'newsFeed') return false
            }

            //verification pour contrer les erreurs backend

            //mettre le status à failed si la date de l'event + 10 minutes est passée et que le status est scheduled
            if (event.originalStatus == 'scheduled' && new Date(event.date).getTime() + 60000 * 10 < Date.now()) {
                event.originalStatus = 'failed'
                event.status = 'failed'
            }

            //rendre la v1 compatible avec la v2
            if (event.content) {
                event.content = event.content.replace(/@\[(.+?) \([^)]+\)]/g, "$1");
            }

            // {{...}} → valeur de la variable pour la page ciblée par ce post (vide si non renseignée)
            if (event.content) {
                event.content = resolveVariables(event.content, store.getters['variables/getVariablesForPage'](event.page.id))
            }

            return event
        },

        async handlerDeletePost(event = this.events[this.eventIdSelected], all = null) {
            this.eventIdSelected = null
            const isPostsMultipaged = this.isPostsMultipaged(event.originalPost)
            console.log("deletePost isPostsMultipaged",isPostsMultipaged, all)
            if (all == null) {
                if (isPostsMultipaged) {

                    setTimeout(() => {
                        EventBus.$emit("showModal", 
                            "Supression", 
                            "Ce post a été réalisé sur plusieurs pages. Souhaitez-vous suprimer pour l'ensemble des pages ? ", 
                            "Toutes les pages", 
                            "Cette page uniquement",  
                            ()=>{
                                this.handlerDeletePost(event, true)
                            },
                            ()=>{
                                this.handlerDeletePost(event, false)
                            },
                        );
                    }, 200);
                    
                    return
                }else{
                    all = false
                }   
            }

            const calendarApi = this.$refs.calendar ? this.$refs.calendar.getApi() : null;
            
            let eventId, eventInstance;
            
            if (event.originalStatus == 'standby') {
                
                await this.excludeNewsToPost(event.originalPost._bots[0].id, event.originalPost)
                this.newLog(
                    event.originalPost.id, 
                    JSON.stringify(this.generateLog({
                        title: 'dash.posts.log.excluded-news',
                    }))
                    , all
                )

                eventId = event.originalPost.id + event.originalPost._bots[0].page.id;
                delete this.events[eventId]
                if(calendarApi) calendarApi.removeEvent(eventId)
                
            }
            else if (event.originalStatus == 'draft') {
                // Le flag isPgDraft renvoyé par le backend n'est pas fiable — on se base sur le
                // format de l'id, comme Posts2.vue:97 (ObjectId Mongo = 24 hex, uuid PG sinon).
                const isPgDraft = !/^[0-9a-f]{24}$/i.test(event.originalPost?.id || '')
                if (isPgDraft) {
                    await this.deleteDraft(event.originalPost.id, isPostsMultipaged && all ? null : event.originalPost._bots[0].page)
                } else {
                    await this.deleteAllPosts(event.originalPost, isPostsMultipaged && all)
                }
                this.newLog(
                    event.originalPost.id,
                    JSON.stringify(this.generateLog({
                        title: 'dash.posts.log.deleted-draft',
                    }))
                    , all
                )

                if (isPgDraft) {
                    const draftPages = event.originalPost.draft?.data?.pages
                    if (isPostsMultipaged && all && draftPages) {
                        console.log('delete all multipage', eventId)
                        draftPages.forEach(pageId => {
                            console.log('delete all pageId', pageId)
                            eventId = event.originalPost.id + pageId
                            delete this.events[eventId]
                            if (calendarApi) calendarApi.removeEvent(eventId)

                            if (this.events[eventId+'_storification']) {
                                delete this.events[eventId+'_storification']
                                calendarApi.removeEvent(eventId+'_storification')
                            }

                            if (this.events[eventId+'_facebook_storification']) {
                                delete this.events[eventId+'_facebook_storification']
                                calendarApi.removeEvent(eventId+'_facebook_storification')
                            }
                        });
                    }else{
                        eventId = event.originalPost.id + event.originalPost._bots[0].page.id;
                        delete this.events[eventId]
                        calendarApi.removeEvent(eventId)

                        if (this.events[eventId+'_storification']) {
                            delete this.events[eventId+'_storification']
                            calendarApi.removeEvent(eventId+'_storification')
                        }

                        if (this.events[eventId+'_facebook_storification']) {
                            delete this.events[eventId+'_facebook_storification']
                            calendarApi.removeEvent(eventId+'_facebook_storification')
                        }
                    }
                } else {
                    // Nouveau brouillon (Mongo/ES) : même mécanique que les posts normaux, chaque page a son propre _id
                    const multipages = (event.originalPost.page[0] && event.originalPost.page[0].posts_multipages) || []
                    const toClean = (isPostsMultipaged && all)
                        ? [{ _id: event.originalPost.id, pageId: event.originalPost._bots[0].page.id }]
                            .concat(multipages.map(({ _id, page: pageId }) => ({ _id, pageId })))
                        : [{ _id: event.originalPost.id, pageId: event.originalPost._bots[0].page.id }]
                    toClean.forEach(({ _id, pageId }) => {
                        const eId = _id + pageId
                        delete this.events[eId]
                        calendarApi.removeEvent(eId)

                        if (this.events[eId+'_storification']) {
                            delete this.events[eId+'_storification']
                            calendarApi.removeEvent(eId+'_storification')
                        }

                        if (this.events[eId+'_facebook_storification']) {
                            delete this.events[eId+'_facebook_storification']
                            calendarApi.removeEvent(eId+'_facebook_storification')
                        }
                    })
                }

                this.getPlannerData(1000)

            }else{
                const response = await this.deleteAllPosts(event.originalPost, all)
                if (response.body.success) {
                    this.newLog(
                        event.originalPost.id,
                        JSON.stringify(this.generateLog({ title: 'dash.posts.log.deleted-post' })),
                        all
                    )
                }
                const multipages = (event.originalPost.page[0] && event.originalPost.page[0].posts_multipages) || []
                const toClean = all
                    ? [{ _id: event.originalPost._id, pageId: event.originalPost._bots[0].page.id }]
                        .concat(multipages.map(({ _id, page: pageId }) => ({ _id, pageId })))
                    : [{ _id: event.originalPost._id, pageId: event.originalPost._bots[0].page.id }]
                toClean.forEach(({ _id, pageId }) => {
                    const eId = _id + pageId
                    delete this.events[eId]
                    calendarApi.removeEvent(eId)
                    Object.keys(this.events)
                        .filter(key => key.startsWith(_id) && (key.endsWith('_storification') || key.endsWith('_facebook_storification')))
                        .forEach(key => {
                            delete this.events[key]
                            calendarApi.removeEvent(key)
                        })
                })
                this.getPlannerData(1000)
            }
        },  
        
        async handleEventClick(eventId, fetchPost=true) {
   
            //convert old draft
            console.log('handleEventClick', this.events[eventId], eventId , this.events[eventId].id)
            if (!this.events[eventId]) return
            const event = this.events[eventId]
            console.log("handleEventClick event", this.events[eventId], eventId, Object.keys(this.events))
            
            if (this.events[eventId].originalStatus == 'draft' && (!this.events[eventId].draft || !this.events[eventId].draft.saveAllFormData)) {
                //post V1
                this.$router.push({ 
                    name: 'planner',
                    query: {
                        no_redirection: true,
                        post_id:  this.events[eventId].originalPost.id,
                        page_id:  this.events[eventId].page.id,
                        bot_id: this.events[eventId].originalPost._bots[0].id,
                        is_draft: this.events[eventId].originalStatus == 'draft',
                        show_post:1
                    }
                });
                return 
            }
            console.log('handleEventClick before convertOldDraft')

            if (this.events[eventId].draft && this.events[eventId].draft.saveAllFormData) {
                patchDraft(this.events[eventId].draft)

                if (eventId.endsWith('_storification')) {
                    this.$set(this.events[eventId].draft, 'tab', "story_share")
                }else if (this.events[eventId].draft.tab == "story_share") {
                    this.$set(this.events[eventId].draft, 'tab', "standard")
                }
            }

            this.eventIdSelected = eventId
        
            console.log('handleEventClick after buildEvent', this.events[eventId])

            //si news 
            if (!this.events[eventId].originalPost.page || !this.events[eventId].originalPost.page.length) {
                this.events[eventId] = await this.buildEvent(this.events[eventId].originalPost, true); 
                return
            }

            if (fetchPost) {
                let body;
                if (this.events[event.id].originalStatus == 'draft') {
                    const post = this.events[event.id].originalPost
                    if (!post?.page?.[0]?.isPgDraft) {
                        // Nouveau brouillon MongoDB : findPost pour avoir la version la plus récente
                        const reponse = await this.findPost(post._bots[0].id, post._id, post.page[0].post_number || null)
                        body = reponse.body
                    } else {
                        const reponse = await this.findDraft(post._bots[0].id, post._id)
                        body = reponse.body
                        // Préserver isPgDraft qui n'est pas retourné par findDraft
                        if (body && body.post && body.post.page) {
                            body.post.page = body.post.page.map(p => ({ ...p, isPgDraft: true }))
                        }
                    }
                }else{
                    const originalPost = this.events[event.id].originalPost
                    let reponse = await this.findPost(originalPost._bots[0].id, originalPost.id, originalPost.page[0].post_number)
                    // /posts/find filters the embeds on post_number, and post_number can change when process finishes
                    // and return no pageEmbeds. In that case search again.
                    if (!reponse || !reponse.body || !reponse.body.post || !reponse.body.post.page || !reponse.body.post.page.length) {
                        reponse = await this.findPost(originalPost._bots[0].id, originalPost.id, null)
                    }
                    body = reponse && reponse.body
                }
                
                console.log('test1', body)
                if (body && body.post && body.post.page && body.post.page.length >= 2) {
                    console.log('test', event.id.endsWith('_storification'),JSON.parse(JSON.stringify(body.post.page)))
                    if (event.id.endsWith('_storification')) {
                        body.post.page = [body.post.page.find(p => p.storification && p.story)]
                    }else{
                        body.post.page = [body.post.page.find(p => !p.storification || !p.story)]
                    }
                }
                if (!body || !body.post) {
                    console.warn('handleEventClick findPost returned no post', event.id, body)
                    return
                }
                console.log('test 2',JSON.parse(JSON.stringify(body.post.page)))

                const newEvent = await this.buildEvent({
                    ...this.events[event.id].originalPost,
                    ...body.post,
                }, true);

                newEvent.id = event.id
                // console.log('handleEventClick after buildEvent', {
                //     newEvent: JSON.parse(JSON.stringify(newEvent)),
                //     lastEvent: JSON.parse(JSON.stringify(this.events[event.id]))
                // })
                this.events[event.id] = {
                    ...newEvent,
                    type: this.events[event.id].type || newEvent.type,
                    reportingData: body.reportingData || null,
                }

                this.handleEventClick(event.id, false) //pour convertir le draft
            }
        },

    },
    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },
    }
  };